module.exports = __webpack_public_path__ + "img/4064007990.162e34ac.jpg";